import { DatePipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../translations';

/**
 * Pipe to format the assessment date.
 */
@Pipe({
    name: 'formatAssessmentDate',
    standalone: false
})
export class FormatAssessmentDatePipe implements PipeTransform {
    private readonly datePipe = inject(DatePipe);
    private readonly TR = inject(TranslationService);

    /**
     * Transforms the date string into a formatted string.
     *
     * @param date
     * @param pending
     */
    transform(date: string, pending: boolean): string {
        const formattedDate = this.datePipe.transform(date, 'MM/dd/yyyy');
        return pending
            ? `${this.TR.key('label.common-terms.sent')} ${formattedDate}`
            : `${this.TR.key('label.common-terms.completed')} ${formattedDate}`;
    }
}
